var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-select',{attrs:{"label":_vm.$t('catalog.category.parentCategory'),"textBy":"description","options":_vm.options,"error":_vm.error},model:{value:(_vm.selectedCat),callback:function ($$v) {_vm.selectedCat=$$v},expression:"selectedCat"}})}
var staticRenderFns = []

export { render, staticRenderFns }